import { SvgProps } from "./Form";

export const TapIcon = (props: SvgProps) => {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_8239_17887)">
        <path
          d="M13 11.6395V13.5C13 13.776 12.7765 14 12.5 14C12.2235 14 12 13.776 12 13.5V11.6395C12 10.927 11.4925 10.3085 10.794 10.1685L7.402 9.48999C7.1685 9.44349 7 9.23799 7 8.99999V5.55349C7 5.28449 6.819 5.04449 6.588 5.00749C6.435 4.98249 6.29 5.02249 6.1765 5.11899C6.0645 5.21399 6 5.35299 6 5.49999V12.319C6 12.511 5.89 12.686 5.717 12.7695C5.545 12.853 5.339 12.8305 5.1885 12.71L3.87 11.66C3.6385 11.446 3.3225 11.457 3.135 11.658C2.947 11.8595 2.9575 12.1775 3.1585 12.3665L3.847 13.0305C4.0455 13.222 4.0515 13.5385 3.8595 13.7375C3.668 13.936 3.3515 13.9415 3.1525 13.75L2.469 13.091C1.8715 12.5305 1.8395 11.5795 2.404 10.9755C2.9685 10.3725 3.9185 10.34 4.5225 10.9035L5 11.283V5.49999C5 5.05949 5.1925 4.64299 5.5285 4.35699C5.864 4.07099 6.309 3.94799 6.748 4.01999C7.4615 4.13549 7.9995 4.79499 7.9995 5.55299V8.58949L10.9895 9.18749C12.154 9.42049 12.9995 10.4515 12.9995 11.639L13 11.6395ZM3.772 7.24999C3.842 7.24999 3.9125 7.23549 3.9805 7.20449C4.2315 7.08949 4.3415 6.79249 4.2265 6.54149C4.076 6.21399 4 5.86349 4 5.49999C4 4.12149 5.1215 2.99999 6.5 2.99999C7.8785 2.99999 9 4.12149 9 5.49999C9 5.86449 8.924 6.21449 8.774 6.54149C8.6585 6.79249 8.7685 7.08949 9.019 7.20449C9.2715 7.31999 9.5675 7.20999 9.682 6.95899C9.893 6.50049 10 6.00949 10 5.50049C10 3.57049 8.43 2.00049 6.5 2.00049C4.57 2.00049 3 3.56999 3 5.49999C3 6.00849 3.107 6.49899 3.3175 6.95849C3.4015 7.14199 3.583 7.24999 3.7725 7.24999H3.772Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_8239_17887">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
